<template>
  <section class="implemented-table">
    <DataTable
      :value="dataSource"
      data-key="Id"
      v-model:filters="filters"
      show-gridlines
      paginator :rows="6"
      :rowsPerPageOptions="[6, 12, 24]"
      edit-mode="row"
      v-model:editing-rows="editingRows"
      state-storage="local"
      scroll-height="80vh"
      :loading="false"
      removable-sort
      class="p-datatable-sm"
      v-model:selection="selectedRow"
      @row-edit-save="$emit('row-edit', $event)"
      @row-dblclick="changeNews"
      @row-select="$emit('row-selected', $event)"
    >
      <template #header>
        <div class="implemented-table__header">
            <h2 class="implemented-table__title">Реализуемые образовательные программы</h2>
            <IconField iconPosition="right" style="position: relative;">
                <InputIcon style="position: absolute; right: 20px; top: 12px;">
                    <i class="pi pi-search" />
                </InputIcon>
                <InputText placeholder="Поиск по таблице" />
            </IconField>
        </div>
      </template>
      <Column
        field="Header"
        header="Наименование"
        style="width: 57.188rem"
      >
        <template #editor="slotProps">
          <InputText v-model="slotProps.data.Header" autofocus />
        </template>
      </Column>
      <Column
        field="PublicationDate"
        header="Форма"
        bodyStyle="text-align:center"
        style="width: 7.563rem"
      >
        <template #body="slotProps">
          {{ formaterDate(slotProps.data.PublicationDate) }}
        </template>
        <template #editor="slotProps">
          <InputText v-model="slotProps.data.PublicationDate" autofocus />
        </template>
      </Column>
      <Column
        field="DefferedDate"
        header="Срок"
        bodyStyle="text-align:center"
        style="width: 6.063rem"
      >
        <template #body="slotProps">
          {{ formaterDateTime(slotProps.data.DefferedDate) }}
        </template>
        <template #editor="slotProps">
          <InputText v-model="slotProps.data.PublicationDate" autofocus />
        </template>
      </Column>
      <Column
        header="Язык"
        :body-style="{ 'text-align': 'center' }"
        style="width: 5.188;"
      >
        <template #editor="slotProps">
          <InputText v-model="slotProps.data.PublicationDate" autofocus />
        </template>
      </Column>
      <Column
        field="PublicationDate"
        header="Учебный план"
        :body-style="{ 'text-align': 'center' }"
        style="width: 9.813rem"
      >
        <template #body="slotProps">
          {{ formaterDate(slotProps.data.PublicationDate) }}
        </template>
        <template #editor="slotProps">
          <InputText v-model="slotProps.data.PublicationDate" autofocus />
        </template>
      </Column>
      <Column
        field="PublicationDate"
        header="Практика"
        :body-style="{ 'text-align': 'center' }"
        style="width: 5.313rem"
      >
        <template #body="slotProps">
          <Checkbox
            v-model="slotProps.data.ReadyToPublish"
            :binary="true"
            disabled
          />
        </template>
      </Column>
      <Column
        field="PublicationDate"
        header="ЭО и ДОТ"
        :body-style="{ 'text-align': 'center' }"
        style="width: 5.313rem"
      >
        <template #body="slotProps">
          <Checkbox
            v-model="slotProps.data.ReadyToPublish"
            :binary="true"
            disabled
          />
        </template>
      </Column>
    </DataTable>
  </section>
</template>

<script>
import { ref, toRef } from 'vue'
import { useStore } from 'vuex'

import { formaterDate, formaterDateTime } from '@/helpers/helpFunctions.js'
import { policiesValid } from '@/helpers/policiesValidator'

import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import InputText from 'primevue/inputtext'
import Checkbox from 'primevue/checkbox'

export default {
  name: 'ImplementedProgramsTable',
  components: {
    DataTable,
    Column,
    InputText,
    Checkbox
  },
  props: {
    data: {
      type: Array,
      default: () => []
    },
    policies: {
      type: Array,
      default: () => []
    }
  },
  setup (props, { emit }) {
    const store = useStore()

    // const policies = computed(() => store.getters.getPolicies)

    // нужно для работы таблицы по документации
    const filters = ref({
      Vendor: { value: null },
      Header: { value: null },
      PublicationDate: { value: null },
      DefferedDate: { value: null },
      UniversalTagId: { value: null },
      ReadyToPublish: { value: null },
      Published: { value: null }
    })

    const editingRows = ref([])

    const selectedRow = ref()
    // нужно для работы таблицы по документации

    const dataSource = toRef(props, 'data')

    const changeNews = (e) => {
      if (!policiesValid(props.policies, e.data.UniversalTagId, 'editing')) {
        store.dispatch('setShowErrorModal', { Message: 'У Вас нет прав на редактирование' })

        return
      }
      // в том случае если пользователь может редактировать товар/новость
      // то эмитится событие ниже, которе слушается из родительского компонента
      emit('redirectToEditor', e.data.Id)
    }

    return {
      filters,
      policiesValid,
      editingRows,
      dataSource,
      formaterDate,
      changeNews,
      selectedRow,
      formaterDateTime
    }
  }
}
</script>

<style lang="scss" scoped>
.implemented-table {

  &__header {
    display: flex;
    justify-content: space-between;
    background: #FFFFFF;
    margin-bottom: 16px;

    :deep(.p-inputtext) {
      width: 300px !important;
      height: 40px !important;
      padding: 8px 16px !important;
      color: #848484;
    }
  }

  &__title {
    font-size: 24px;
    color: #000000;
  }

  :deep(.p-datatable.p-datatable-gridlines .p-datatable-thead > tr > th) {
    background-color: #FFFFFF;
    border-top: none;
    border-left: none;
    border-right: none;
    padding: 4px;
  }

  :deep(.p-column-title) {
    color: #A8A8A8;
    font-weight: 400;
  }

  :deep(.p-paginator .p-paginator-pages .p-paginator-page) {
    border-radius: 18px;
  }

  :deep(.p-paginator .p-paginator-pages .p-paginator-page.p-highlight) {
    background: #1BA6DA;
    color: #FFFFFF;
    border-radius: 18px;
  }

  :deep(.p-inputtext) {
    width: 100%;
    height: 100%;
  }
}
</style>
